// Modul zur Erfassung von einfachen Kosten
"use strict";

import module from "./module.js";
// import "./tests.spec.js";

export default module;
